exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selected[data-v-bece1f7e] {\n    background: #d3d3d1;\n}\n\n", ""]);

// exports
